import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as projectReducer from "containers/Project/reducer";

import * as DatasetAPI from "api/DatasetAPI";

const UPDATE_FIELD = "consumer/UPDATE_FIELD";

const initialState = {};

function consumerReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.consumer;
}

export function getDatasetId(state) {
  return getBase(state) ? getBase(state).datasetId : undefined;
}

export function getProjectId(state) {
  return getBase(state) ? getBase(state).projectId : undefined;
}

export function getMode(state) {
  return getBase(state) ? (getBase(state).mode ? getBase(state).mode : "OVERVIEW") : "OVERVIEW";
}

/* Actions */
export function updateDatasetId(datasetId) {
  return (dispatch, getState) => {
    //dispatch(updateProjectId(undefined));

    return dispatch({
      type: UPDATE_FIELD,
      key: "datasetId",
      data: datasetId
    });
  };
}

export function updateProjectId(projectId) {
  return (dispatch, getState) => {
    if (projectId !== undefined) {
      const overallRunId = projectReducer.getOverallRunId(getState(), projectId);
      const datasetId = setupReducer.getDatasetId(getState(), overallRunId);
      const blueprintId = setupReducer.getBlueprintId(getState(), overallRunId);

      dispatch(unifiedProjectReducer.init(projectId, blueprintId, datasetId));

      dispatch(updateDatasetId(datasetId));

      return dispatch({
        type: UPDATE_FIELD,
        key: "projectId",
        data: projectId
      });

      return Promise.resolve();
    } else {
      return dispatch({
        type: UPDATE_FIELD,
        key: "projectId",
        data: projectId
      });
    }
  };
}

export function updateMode(mode) {
  return (dispatch, getState) => {
    if (mode === "DATA") {
      const projectId = getProjectId(getState());

      const overallRunId = projectReducer.getOverallRunId(getState(), projectId);
      const datasetId = setupReducer.getDatasetId(getState(), overallRunId);

      dispatch(updateDatasetId(datasetId));
    }

    return dispatch({
      type: UPDATE_FIELD,
      key: "mode",
      data: mode
    });
  };
}

export function reloadProject() {
  return (dispatch, getState) => {
    const projectId = getProjectId(getState());
    return dispatch(unifiedProjectReducer.reloadProject(projectId));
  };
}

export default consumerReducer;
